module.exports = {"451082100":"马头镇","451082101":"新安镇","451082102":"果化镇","451082103":"太平镇","451082104":"坡造镇","451082105":"四塘镇","451082106":"旧城镇","451082107":"榜圩镇","451082108":"凤梧镇","451082202":"海城乡","451082205":"黎明乡","451082206":"同老乡","451082450":"平果铝"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451082.json
// module id = 2281
// module chunks = 0